import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials: true is required for the httpOnly cs_session cookie set by
// /auth/login + /auth/register to ride along on every API request.
const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export default api;

/**
 * Request a short-lived (5-min) signed download token.
 * Then open `${API_BASE}/{path}?auth=<token>` to trigger the download.
 * Keeps long-lived JWTs out of URLs / access logs / browser history.
 */
export async function openSignedDownload(resource, resourceId, path) {
  const { data } = await api.post("/downloads/sign", {
    resource,
    resource_id: resourceId || "",
  });
  const url = `${API_BASE}${path}?auth=${encodeURIComponent(data.token)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
